export const xeroAccountLists = [
  'Accounts Receivable',
  'Balance Sheet',
  'Cashflow',
  'Client',
  'Employee',
  'Employee Utilisation',
  'General Ledger',
  'Income Statement',
  'Project',
  'Opportunity',
];

export const sqlAccountLists = [
  'Accounts Receivable',
  'Balance Sheet',
  'Cashflow',
  'Client',
  'Employee',
  'Employee Utilisation',
  'General Ledger',
  'Income Statement',
  'Project',
  'Opportunity',
  'Work Generated',
];

export const myobAccountLists = [
  'Accounts Receivable',
  'Balance Sheet',
  'Cashflow',
  'Client',
  'Employee',
  'Employee Utilisation',
  'General Ledger',
  'Income Statement',
  'Project',
  'Opportunity',
];

export const rapportAccountLists = [
  'Accounts Receivable',
  'Client',
  'Employee',
  'Employee Utilisation',
  'Project',
  'Opportunity',
  'Work Generated',
];

export const workflowAccountLists = [
  'Accounts Receivable',
  'Client',
  'Project',
  'Opportunity',
];

export const manaualEntryAccountLists = [
  'Accounts Receivable',
  'Balance Sheet',
  'Cashflow',
  'Client',
  'Employee',
  'Employee Utilisation',
  'General Ledger',
  'Income Statement',
  'Project',
  'Opportunity',
  'Work Generated',
];

export const synergyAccountLists = [
  'Accounts Receivable',
  'Balance Sheet',
  'Cashflow',
  'Client',
  'Employee',
  'Employee Utilisation',
  'General Ledger',
  'Income Statement',
  'Project',
  'Opportunity',
  'Work Generated',
];

export const deltekVpAccountLists = [
  'Accounts Receivable',
  'Balance Sheet',
  'Income Statement',
  'Cashflow',
  'Client',
  'Employee',
  'Employee Utilisation',
  'General Ledger',  
  'Project',
  'Opportunity',
  'Work Generated',
];

export const simplifyAccountLists = [
  'Project',
  'Employee Utilisation',
  'Opportunity',
  'Opportunity Performance',
  'Work Generated',
  'Project Forecast',
];

export const reportDataTableNames = [
  'General Ledger',
  'Employee',
  'Employee Holiday',
  'Client',
  'Opportunity',
  'Project',
  'Project Performance Summary',
  'Balance Sheet',
  'Income Statement',
  'Accounts Receivable',
  'Cashflow',
  'Financial Metric',  
  'Employee Utilisation',
  'Employee Forecast',
  'Opportunity Performance',
  'Work Generated',
  'KPI Result',
];
